import React from "react";
import Container from "react-bootstrap/Container";
import { FormattedMessage } from "react-intl";
import "./index.css";

export default function AboutUs() {
  return (
    <div className="about-us-wrapper content-wrapper">
      <Container>
        <div className="real-content" itemProp="text">
          <h2 className="info-page-title"><FormattedMessage id="page.about-us.title" /></h2>
          <div className="info-page-text">
            <p><FormattedMessage id="page.about-us.content" /></p>
          </div>
          <div className="clear"></div>
        </div>
      </Container>
    </div>
  );
}
